import {
  getSEOIntentConfig,
  localizeSEOIntentConfig,
  type SEOIntentConfig,
} from "@/lib/seo-intents";
import type { KundaliLang } from "./KundaliFormCard.i18n";

/** The captured intent's CTA in the form's language: an intent captured on an
 * English page must not leave an English submit button on a Hindi form. */
export function seoCtaLabel(
  seoEntry: { config: SEOIntentConfig } | null,
  language: KundaliLang
): string | undefined {
  return seoEntry ? localizeSEOIntentConfig(seoEntry.config, language).ctaLabel : undefined;
}

/** The intent prompt in the form's language. A seeker's own question (a custom
 * `prompt`) is shown as typed; only the intent's stock English prompt is swapped. */
export function seoPromptLabel(config: SEOIntentConfig, language: KundaliLang): string {
  if (language !== "hi" || config.prompt !== getSEOIntentConfig(config.intent).prompt) {
    return config.prompt;
  }
  return localizeSEOIntentConfig(config, language).prompt;
}
